import { connect } from 'react-redux';
import React, { Component } from 'react';
import { renderKBInput, renderKBUserInput, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';

import { bindActionCreators } from 'redux';
import * as valid from 'utils/validate';
import { api } from 'app/services';
import { subscriptionPlaceholder } from 'app/actions';
import {
KBInput,
KBPopover,
KBFormError,
KBButton } from
'components';
import * as selectors from 'app/selectors';
import dayjs from 'utils/dayjs';

var SpaceTempletePlaceholderForm = class extends React.Component {constructor(props) {super(props);this.createPlaceholderForm = this.createPlaceholderForm.bind(this);}createPlaceholderForm(

  model) {
    const { updateSubscriptionPlaceholderAction } = this.props;
    delete model.placeholderId;

    return api.createSubscriptionSpecialPlaceholder(model).then(
    ({ json }) => {
      let obj = {};
      obj[json.id] = json;
      updateSubscriptionPlaceholderAction.success({
        entities: { subscriptionPlaceholder: obj } });

      KBPopover.close();
    },
    error => {
      updateSubscriptionPlaceholderAction.failure(error);
    });

  }componentDidMount()

  {
    const {
      fields: { name, description } } =
    this.props;
    name.onChange('office_area_name');
    description.onChange('办公地点名称');
  }render()

  {
    const {
      fields: { placeholderId, value },
      error,
      submitting,
      handleSubmit } =
    this.props;

    const placeholderSpecial = [
    {
      id: 1,
      name: '办公地点名称' }];


    return (
      <form onSubmit={handleSubmit(this.createPlaceholderForm)}>
        <div>
          <header className="kb-form-header">
            <h2 className="header-title">创建模板命令字符</h2>
            <i
            className="iconfont header-close icon-cancel"
            onClick={KBPopover.close} />

          </header>
          <KBFormError err={this.props.error} />
          <div className="kb-form-container">
            <div className="kb-row">
              <Field name="placeholderId" component={renderKBUserInput}
              title="模板命令"
              placeholder="选择模板命令"
              className="kb-form-group kb-form-210 kb-form-alone"

              isRequired={true}
              multi={false}
              users={placeholderSpecial}
              selectedUsers={[]} />

            </div>
            <div className="kb-row">
              <Field name="value" component={renderKBInput}
              className="kb-form-group kb-form-210 kb-form-alone"
              isRequired={true}

              title="命令字符值" />

            </div>
            <div className="kb-row">
              <KBButton
              className="certain-btn"
              type="submit"
              submitting={submitting}>

                确定
              </KBButton>
              <span className="cancel-btn" onClick={KBPopover.close}>
                取消
              </span>
            </div>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    updateSubscriptionPlaceholderAction: bindActionCreators(
    subscriptionPlaceholder.update,
    dispatch) };


}

const validate = values => {
  const errors = {};

  if (valid.required(values.value)) {
    errors.value = '请输入命令字符值';
  }

  if (valid.required(values.placeholderId)) {
    errors.placeholderId = '请选择模板命令';
  }

  return errors;
};

const formConfig = {
  form: 'ChanceForm',
  touchOnBlur: false,
  validate: validate };


const LEGACY_FORM_FIELDS = [
  "name",
  "description",
  "placeholderId",
  "value"
];


SpaceTempletePlaceholderForm = connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('ChanceForm', LEGACY_FORM_FIELDS)(SpaceTempletePlaceholderForm)));

export default SpaceTempletePlaceholderForm;
